import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-office-admin-sales-report',
  templateUrl: './office-admin-sales-report.component.html',
  styleUrls: ['./office-admin-sales-report.component.scss']
})
export class OfficeAdminSalesReportComponent implements OnInit {

  leadType:any;
  commitionToOfLead:any;
  checkOVRInAgencyCode: any;
  constructor(private router:Router) { }

  ngOnInit(): void {
    this.leadType=sessionStorage.getItem('leadtype');
    this.commitionToOfLead=sessionStorage.getItem('commitionToOfLead');
  }
  goToReportDetails(type){
    localStorage.setItem('report-type',type);
    this.router.navigate(['/dashboard/OASale-report-details']);
  }
}
